import {
    useCallback, useMemo,
} from 'react'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import Card from 'app/shared-components/Card'
import {
    RichTableData,
} from 'app/types/richtable.types'
import useLabel from 'app/hooks/useLabel'
import {
    Currency,
} from 'app/enums/label.enums'

import {
    LaneFees,
} from '../../CQuotes.types'
import getColumns from './laneFeesTable.columns'
import useStyles from './laneFeesTable.styles'

const LaneFeesTable = ({
    value,
    currency,
    title,
}: {
    value: LaneFees[],
    currency: Currency,
    title: string,
}) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const load = useCallback((): Promise<RichTableData<LaneFees[]>> => {
        return Promise.resolve({
            data: value,
        })
    }, [value])

    const columns = useMemo(() => {
        return getColumns(l, currency)
    }, [
        currency,
        l,
    ])

    return (
        <Card
            title={title}
            className={classes.card}
        >
            <RichTable
                configName="LaneFeesTable"
                name="LaneFees"
                columns={columns}
                load={load}
                className={classes.tableContent}
                classNames={{
                    contentWrapper: classes.tableContentWrapper,
                }}
            />
        </Card>
    )
}

export default LaneFeesTable
